import {versionController} from '../../../shared/scripts/EntryShared'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {ViewPopupLogin} from '../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'
import {UserSessionUtils} from '../../../shared/scripts/UserSessionUtils'
import {DurationConverter, RandomUtils, TimeUtils} from '@colonist/utils'
import {DiscordInstance} from '../discord/DiscordInstance.ts'
import {AnalyticEventValue} from '../../../../shared/entity_datas/EntityDatas'
import {ViewPopupBecomeMemberGameplay} from '../../../shared/scripts/ui_popup/ViewPopupBecomeMemberGameplay'
import {ViewPopupBecomeMemberBasic} from '../../../shared/scripts/ui_popup/ViewPopupBecomeMemberBasic'
import {SDKRequest} from '../../../../shared/DiscordActivityTypes'
import {ColonistMembershipType} from '@colonist/types'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils.ts'

export class UIPopupFunnelIncentiveController {
    private static showMembershipIncentivePopup(accessGameFromLink: boolean) {
        if(accessGameFromLink) return
        const lastMembershipIncentivePopupTime = StorageWrapper.getLastMembershipIncentivePopupTime()
        if(UIPopupFunnelIncentiveController.membershipIncentivePopupWasShownInLastTwentyFourHours(lastMembershipIncentivePopupTime)) return

        const showGameplayPopup = UIUtilsEjsVariables.isUserOnDiscord || RandomUtils.randomBool()
        const analyticEventValue = UIUtilsEjsVariables.isUserOnDiscord ? AnalyticEventValue.PopupMembershipIncentiveDiscordGeneral : AnalyticEventValue.PopupMembershipIncentiveSubscription
        const checkAction = UIUtilsEjsVariables.isUserOnDiscord ? () => {
            void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, ColonistMembershipType.PremiumMonthly)
        } : () => {
            navigateToPage('/store#membership', true)
        }
        showGameplayPopup ? new ViewPopupBecomeMemberGameplay(checkAction, analyticEventValue) : new ViewPopupBecomeMemberBasic(checkAction, analyticEventValue)
        StorageWrapper.setLastMembershipIncentivePopupTime(new Date())
    }

    private static membershipIncentivePopupWasShownInLastTwentyFourHours(lastMembershipIncentivePopupTime: Date | null): boolean {
        if(lastMembershipIncentivePopupTime == null) return false
        const millisecondsSinceLastMembershipIncentivePopupTime = TimeUtils.millisecondsPassedSince(lastMembershipIncentivePopupTime.getTime())
        const shownWithinLastDay = millisecondsSinceLastMembershipIncentivePopupTime < DurationConverter.daysAsMilliseconds(1)
        return shownWithinLastDay
    }

    static showPopup(accessGameFromLink: boolean) {
        if(versionController?.willShowPatchnoteThisSession) return

        if(UserSessionUtils.canShowLoginPopup()) new ViewPopupLogin()
        else if(UserSessionUtils.canShowSubscriptionPopup()) UIPopupFunnelIncentiveController.showMembershipIncentivePopup(accessGameFromLink)
    }
}
